// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/purchasehistory/v1/legacy_portal_service.proto (package spwn.purchasehistory.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest, LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse, LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest, LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * 購入履歴。ログインユーザー本人の注文のみを返す
 *
 * @generated from service spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryService
 */
export const LegacyPortalPurchaseHistoryService = {
    typeName: "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryService",
    methods: {
        /**
         * 購入履歴一覧を取得。表示対象の注文を注文日時の降順で返す
         *
         * @generated from rpc spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryService.ListPurchaseHistory
         */
        listPurchaseHistory: {
            name: "ListPurchaseHistory",
            I: LegacyPortalPurchaseHistoryServiceListPurchaseHistoryRequest,
            O: LegacyPortalPurchaseHistoryServiceListPurchaseHistoryResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 注文を1件取得。本人の注文でなければNotFound
         *
         * @generated from rpc spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryService.GetPurchaseHistoryOrder
         */
        getPurchaseHistoryOrder: {
            name: "GetPurchaseHistoryOrder",
            I: LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderRequest,
            O: LegacyPortalPurchaseHistoryServiceGetPurchaseHistoryOrderResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map